import { render, staticRenderFns } from "./IrrigationTab.vue?vue&type=template&id=4483ad30&scoped=true&"
import script from "./IrrigationTab.vue?vue&type=script&lang=js&"
export * from "./IrrigationTab.vue?vue&type=script&lang=js&"
import style1 from "./IrrigationTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4483ad30",
  null
  
)

export default component.exports